<template>
<div class="container">
<div class="col-md-12">
   <div class="col-lg-12 col-md-12 col-sm-12 col-md-12">
      <div class="table-responsive" style="display: block;margin-top: 20px;">
         <h3>Kết quả đấu giá</h3>
         <table class="table">
            <thead>
               <tr>
                  <th>Thời gian kết thúc</th>
                  <th style="min-width: 150px;">Tên cuộc đấu giá</th>
                  <th>Trạng thái</th>
               </tr>
            </thead>
            <tbody>
               <tr v-for="i in list_auction_done">
                  <td class="date">
                    {{i.PhienDauGia.KetThuc | formatDate}}
                  </td>
                  <td class="bid"><a style="text-decoration: underline;" v-on:click="view(i.PhienDauGia.Id)">
                      {{i.PhienDauGia.TenKeHoach}}</a></td>
                  <td v-if="i.TrangThai==5" class="username">Thành Công</td>
                  <td v-else-if="i.TrangThai==6" class="username">Không Thành Công 
                     <template v-if="i.GhiChu && i.GhiChu!=''">
                        (lý do: {{i.GhiChu}})
                     </template>
                  </td>
               </tr>
               <!-- <tr>
                  <td class="date">
                    10:00 11/07/2020
                  </td>
                  <td class="bid"><a>
                     Đấu giá Quyền nhận chuyển nhượng sử dụng đất, nhà ở và tài sản gắn liền với đất của bà Phạm Thị Minh Yến</a></td>
                  <td class="username">Không thành (lý do: không có người đăng ký tham gia đấu giá)</td>
               </tr> -->
            </tbody>
         </table>
      </div>
   </div>
</div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
import moment from 'moment'
import Auction from "@/common/api/auction"
import CONFIG from '@/common/config'

export default {
  name: 'AuctionResult',
  mixins: [mixin],
  data () {
    return {
        list_auction_done: [],
    }
  },
  created() {
     this.getListAuctionDone()
  },
  filters: {
        formatDate: function (value) {
            if (!value) return ''
            return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
        }
    },
  methods: {
    view(id){
        this.$router.push("/product/auction/"+id)
    },
    getListAuctionDone(){
       Auction.getList(CONFIG.ID_AUCTION_DONE)
      .then(({ data }) => {
         this.list_auction_done = data.Data;
      })
      // Auction.getListDone()
      // .then(({ data }) => {
      //    this.list_auction_done = data.Data;
      // })
   },
  },
}
</script>

<style scoped>
table, th, td {
   border: 1px solid #e6e6e6;
} 
td,
th {
    padding: 10px 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/AuctionResult.vue